export default __webpack_public_path__ + "static/media/logo.2617cf1d.svg";